import ButtonImageSliced from '../ButtonImageSliced.js';
import { Colors } from '../../consts/Colors.js';
import QcmA2 from './QcmA2.js';

export default class Part1 extends Phaser.GameObjects.Container {
    constructor(scene, partData, screenManager) {
        super(scene, 0, 0, []);
        scene.add.existing(this);
        this.scene = scene;
        this.partData = partData
        this.step = 0
        this.screenManager = screenManager
        this.inneDone = false

        this.scene.addSounds()

        this.partContainer = this.scene.add.container(1920, 0);
        this.add(this.partContainer);


        this.qcm = new QcmA2(this.scene, this.partData[0], this);
        this.partContainer.add(this.qcm)
        this.animateIn(1)
        this.clickSound = this.scene.sound.add('click', { volume: 0.4 });
    }

    changeScreen() {
        this.qcm?.destroy()
        this.screenData = this.partData[this.step];
        this.transitionOut(() => {
            if (this.step === 1) {
                this.makeScreen1()
                this.animateIn(2)
                this.inneDone ? this.btn2Rect.setInteractive({ useHandCursor: true }).setAlpha(1) : null
            } else {
                this.createNavButtons()
                this.buildBaseTexts()
                this.createMainImage()
                this.animateIn(3)
            }
        })
    }

    nextFunction() {
        switch (this.step) {
            case 2:
                this.step = 3
                this.transitionOut(() => {
                    this.changeScreen()
                    // this.animateIn(4)
                    
                })
                break;
            case 3:
                this.step = 1
                this.inneDone = true
                this.transitionOut(() => {
                    this.changeScreen()
                    // this.animateIn(5)
                })
                break;
            case 4:
                this.step = 5
                this.transitionOut(() => {
                    this.changeScreen()
                    // this.animateIn(6)
                })
                break;
            case 5:
                this.screenManager.changePart(2)
                break
        }
    }
    previewFunction() {
        switch (this.step) {
            case 2:
                this.step = 1
                this.transitionOut(() => {
                    this.changeScreen()
                    this.animateIn(7)
                })
                break;
            case 3:
                this.step = 2
                this.transitionOut(() => {
                    this.changeScreen()
                    this.animateIn(8)
                })
                break;
            case 4:
                this.step = 1
                this.transitionOut(() => {
                    this.changeScreen()
                    this.animateIn(9)
                })
                break;
            case 5:
                this.step = 4
                this.transitionOut(() => {
                    this.changeScreen()
                    this.animateIn(10)
                })
                break;
        }
    }

    makeScreen1() {
        this.btn1Rect = this.scene.add.rexRoundRectangle(this.screenData.btn1.btn1X, this.screenData.btn1.btn1Y, 350, 250, 15, Colors.Elmt.lightBlue).setOrigin(0.5);
        this.Btn1Stroke = this.scene.add.rexRoundRectangle(this.screenData.btn1.btn1X - 10, this.screenData.btn1.btn1Y - 10, 350, 250, 15, Colors.Elmt.lightBlue, 0).setOrigin(0.5);
        this.Btn1Stroke.setStrokeStyle(4, Colors.Elmt.Black);
        this.btn1Text = this.scene.createTextElement(this.screenData.btn1.btn1X, this.screenData.btn1.btn1Y, this.screenData.btn1);
        this.btn1Rect.setInteractive({ useHandCursor: true })
        this.btn1Rect.on('pointerdown', () => {
            this.clickSound.play();
            this.step = 2
            this.changeScreen()
        })
        this.btn1Rect.on('pointerover', () => {
            this.btn1Rect.setFillStyle(Colors.Elmt.MainBlue)
        })
        this.btn1Rect.on('pointerout', () => {
            this.btn1Rect.setFillStyle(Colors.Elmt.lightBlue)
        })

        this.btn2Rect = this.scene.add.rexRoundRectangle(this.screenData.btn2.btn2X, this.screenData.btn2.btn2Y, 350, 250, 15, Colors.Elmt.lightBlue).setOrigin(0.5);
        this.Btn2Stroke = this.scene.add.rexRoundRectangle(this.screenData.btn2.btn2X - 10, this.screenData.btn2.btn2Y - 10, 350, 250, 15, Colors.Elmt.lightBlue, 0).setOrigin(0.5);
        this.Btn2Stroke.setStrokeStyle(4, Colors.Elmt.Black);
        this.btn2Text = this.scene.createTextElement(this.screenData.btn2.btn2X, this.screenData.btn2.btn2Y, this.screenData.btn2);
        // this.btn2Rect.setInteractive({ useHandCursor: true })
        // this.btn2Rect.setFillStyle(Colors.Elmt.MidBlue)
        this.btn2Rect.setAlpha(0.4)
        
        this.btn2Rect.on('pointerdown', () => {
            this.clickSound.play();
            // this.scene.showScreen('screen1')
            this.step = 4
            this.changeScreen()
        })
        this.btn2Rect.on('pointerover', () => {
            this.btn2Rect.setFillStyle(Colors.Elmt.MainBlue)
        })
        this.btn2Rect.on('pointerout', () => {
            this.btn2Rect.setFillStyle(Colors.Elmt.lightBlue)
        })

        this.partContainer.add(this.btn1Rect)
        this.partContainer.add(this.Btn1Stroke)
        this.partContainer.add(this.btn1Text)
        this.partContainer.add(this.btn2Rect)
        this.partContainer.add(this.btn2Text)
        this.partContainer.add(this.Btn2Stroke)

        this.buildBaseTexts()
    }

    createNavButtons() {
        this.nextBtn = new ButtonImageSliced(this.scene, 1710, 990, 320, 80, "bouton", "Suivant");
        this.add(this.nextBtn);
        this.nextBtn.setClickFunction(() => this.nextFunction());
        if (this.step !== 0) {
            this.previewBtn = new ButtonImageSliced(this.scene, 220, 990, 320, 80, "bouton", "Précédent");
            this.add(this.previewBtn);
            this.previewBtn.setClickFunction(() => this.previewFunction());
        }
    }

    buildBaseTexts() {
        this.title = this.scene.createTextElement(this.screenData.title.titleX, this.screenData.title.titleY, this.screenData.title);
        this.partContainer.add(this.title);
        this.content = this.scene.createTextElement(this.screenData.content.contentX, this.screenData.content.contentY, this.screenData.content);
        this.partContainer.add(this.content);
    }

    createMainImage() {
        this.image = this.scene.add.image(this.screenData.imgX, this.screenData.imgY, this.screenData.img).setOrigin(0.5);
        this.partContainer.add(this.image);
    }
    animateIn(step) {
        this.scene.playSound('whoosh');
        console.log("whoosh triggered step ", step);
        this.scene.tweens.add({
            targets: this.partContainer,
            x: 0,
            duration: 300,
            ease: 'Power2'
        });
    }

    transitionOut(onComplete) {
        // Remove nav buttons to avoid duplicate handlers
        this.nextBtn?.destroy();
        this.previewBtn?.destroy();
        this.scene.tweens.add({
            targets: this.partContainer,
            x: 1920,
            duration: 300,
            ease: 'Power2',
            onComplete: () => {
                this.partContainer.destroy();
                this.partContainer = this.scene.add.container(1920, 0);
                this.add(this.partContainer);
                onComplete && onComplete();
            }
        });
    }

}